import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="This page does not exist." path="/404" noindex />
      <section className="container-wide py-32 text-center" data-testid="not-found">
        <div className="text-xs uppercase tracking-widest text-accent mb-3">404</div>
        <h1 className="font-serif text-5xl sm:text-6xl text-foreground mb-4">Page not found</h1>
        <p className="text-foreground/70 max-w-md mx-auto mb-8">
          The page you are looking for doesn&apos;t exist. Head back home or explore our services.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm hover:bg-primary/90">
            Go Home
          </Link>
          <Link to="/services" className="inline-flex items-center rounded-full border border-border px-5 py-2.5 text-sm hover:bg-secondary">
            View Services
          </Link>
        </div>
      </section>
    </>
  );
}
